export default {
  name: '',
  email: '',
  company: {
    rfc: '',
    tradeName: '',
    accountNumber: '',
    projectName: '',
    name: '',
    oldRfc: '',
    employerRegistration: '',
    multiUser: '',
  },
  list: [],
  role: 'customer',
  sendEmail: false,
  count: 0,
  total: 0,
  totalCount: 0,
  totalPages: 0,
  page: 1,
  size: 20,
  csv: null,
  csvFileName: '',
  userId: null,
  success: '',
  message: false,
  phoneNumber: '',
};
